import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { DRONE_TRACKING_OPTIONS } from '../config/drone-tracking-options';
import {
  DetectedDroneDto,
  DetectedDronesRecentQuery,
  normalizeDetectedDroneResponse,
} from '../models/detected-drone.model';

@Injectable({
  providedIn: 'root',
})
export class DetectedDroneApiService {
  private readonly http = inject(HttpClient);
  private readonly options = inject(DRONE_TRACKING_OPTIONS);
  private readonly baseUrl = this.options.apiBaseUrl.replace(/\/$/, '');

  getRecentDetectedDrones(query: DetectedDronesRecentQuery = {}): Observable<DetectedDroneDto[]> {
    let params = new HttpParams();

    if (query.time) {
      params = params.set('time', query.time.toISOString());
    }

    if (typeof query.lookbackSeconds === 'number' && Number.isFinite(query.lookbackSeconds)) {
      params = params.set('lookbackSeconds', String(Math.max(0, Math.round(query.lookbackSeconds))));
    }

    return this.http
      .get<DetectedDroneDto | DetectedDroneDto[]>(`${this.baseUrl}/api/drones-detected/recent`, { params })
      .pipe(map((response) => normalizeDetectedDroneResponse(response)));
  }
}
